import React from 'react';
import { Box, Typography, Alert, Link } from '@mui/material';
import { colors, fonts, spacing, borderRadius } from '../../../constants';
import { downloadCSVTemplate, downloadExcelTemplate } from '../../../utils/importUtils';
import { templateSectionStyles, templateLinkStyles, infoAlertStyles } from '../../../constants/importDialog';

/**
 * TemplateDownloadSection Component
 * Section for downloading CSV and Excel templates
 */
const TemplateDownloadSection = () => {
  return (
    <Box sx={templateSectionStyles}>
      <Typography
        variant="body2"
        sx={{
          color: colors.textSecondary,
          fontSize: fonts.fontSizeXs,
          fontWeight: fonts.weightMedium,
          mb: spacing.xs,
        }}
      >
        Need a template?
      </Typography>
      <Box
        sx={{
          display: 'flex',
          gap: spacing.md,
          flexWrap: 'wrap',
        }}
      >
        <Link component="button" onClick={downloadExcelTemplate} sx={templateLinkStyles}>
          📊 Download Excel Template
        </Link>
        <Link component="button" onClick={downloadCSVTemplate} sx={templateLinkStyles}>
          📄 Download CSV Template
        </Link>
      </Box>
      <Typography
        variant="caption"
        sx={{
          color: colors.textSecondary,
          fontSize: fonts.fontSizeXs,
          fontStyle: 'italic',
          mt: spacing.xs,
          fontWeight: fonts.weightMedium,
        }}
      >
        Templates include sample data that you can edit and import
      </Typography>

      <Alert severity="info" sx={infoAlertStyles}>
        <Typography variant="body2" sx={{ fontSize: fonts.fontSizeXs, mb: spacing.xs, fontWeight: fonts.weightSemiBold }}>
          <strong>Required columns:</strong> Name, Email
        </Typography>
        <Typography variant="body2" sx={{ fontSize: fonts.fontSizeXs, mb: spacing.xs, fontWeight: fonts.weightSemiBold }}>
          <strong>Optional columns:</strong> Password, Role, Designation, Region, Department, WhatsApp Number, Can Be
          Assignee, Can Be Assignor, Escalation Level, Is Active, Projects
        </Typography>
        <Typography variant="body2" sx={{ fontSize: fonts.fontSizeXs }}>
          If password is not provided, a default password will be assigned.
        </Typography>
      </Alert>
    </Box>
  );
};

export default TemplateDownloadSection;
